import React from "react";
import { useNavigate } from 'react-router-dom';
import "./Allservices.css";
import { Link } from "react-router-dom";



function Allservices2(){

    const navigate = useNavigate();

    return(
        <div>
<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
    <img src="/logo.png" alt="logo" />
    <h5 className="mb-0">
      <span>SVT</span><br />
      DIGITAL INFO TECH
    </h5>

    {/* Toggler Button */}
    <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

    {/* Collapse menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
       <Link className="nav-link" to="/">
  <i className="fa-solid fa-house"></i> HOME
</Link>
        </li>

        <li className="nav-item dropdown">
        <Link
  className="nav-link dropdown-toggle"
  to="/allservices2"
  id="navbarDropdownMenuLink"
  role="button"
  data-bs-toggle="dropdown"
  aria-expanded="false"
>
  <i className="fa-solid fa-desktop" onClick={() => navigate('/allservices2')}
></i> SERVICES
</Link>

          <ul
            className="dropdown-menu p-3 custom-dropdown"
            aria-labelledby="navbarDropdownMenuLink"
            style={{ minWidth: '600px' }}
          >
            <div className="row">
              <div className="col-6">
<li>
  <Link className="dropdown-item" to="/website">
    <i className="fa-solid fa-desktop"></i> Website
  </Link>
</li>               <li>
  <Link className="dropdown-item" to="/graphicwork">
    <i className="fa-solid fa-fire"></i> Graphic Work
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/ecommerce">
    <i className="fa-solid fa-cart-shopping"></i> Ecommerce Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/software">
    <i className="fa-solid fa-tv"></i> Software Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/business">
    <i className="fa-solid fa-chart-line"></i> Business Consulting
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/erp">
    <i className="fa-solid fa-computer"></i> ERP Software
  </Link>
</li>
              </div>
              <div className="col-6">
               <li>
  <Link className="dropdown-item" to="/search">
    <i className="fa-solid fa-rocket"></i> Search Engine Optimization
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/digitalmarketing">
    <i className="fa-solid fa-satellite-dish"></i> Digital Marketing
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/socialmedia">
    <i className="fa-brands fa-hubspot"></i> Social Media Management
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/lead">
    <i className="fa-solid fa-network-wired"></i> Lead Generation
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/businessbrand">
    <i className="fa-solid fa-tag"></i> Business Branding
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/hr">
    <i className="fa-brands fa-searchengin"></i> HR Services
  </Link>
</li>
              </div>
            </div>
          </ul>
        </li>

        <li className="nav-item">
        <Link className="nav-link" to="/about">
  <i className="fa-solid fa-circle-info"></i> ABOUT US
</Link>
        </li>

        <li className="nav-item">
      <Link className="nav-link" to="/form">
  <i className="fa-solid fa-address-book"></i> CONTACT
</Link>
        </li>

      </ul>
    </div>
  </div>
</nav>

<div className="centerimage">
<img src="/servicefront1.png" className="img-fluid" alt="..."  />
  <a href="#first"><button className="btn" >View More <i class="fa-solid fa-circle-arrow-right"></i></button></a>
 </div>

{/* one */}
 <div className="card mb-3  margins"  id="first" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="/website1.png" className="img-fluid rounded-start custom-img " alt="..." />
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">Website Designing</h1>
         <h5 className="text">Build your digital identity with stunning, responsive websites.<br/>
      we design user-friendly websites that reflect your brand and drive results.<br/>From business pages to e-commerce, we craft every pixel<br/>
       with purpose.Get a website that works beautifully on all devices.Let your website speak for your 
        business—professionally.</h5>
         <div className="quotes">
            <h4>"Let your website speak for your business—professionally."</h4>
        </div>
         <button className="but1" onClick={() => navigate("/website")} >View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2" >START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

  {/* Two */}
   <div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">Graphic Work</h1>
         <h5 className="text">Bring your brand to life with powerful visuals.We create eye-catching logos, posters, flyers, and<br/> 
complete graphic solutions that speak your message loud and clear.Every design is crafted to <br/> 
stand out and leave a lasting impression.Whether it’s for print or digital, we deliver creativity that connects.Design that
 defines your identity—professionally.</h5>
 
 <div className="quotes">
            <h4>"Designs that define your identity and capture attention."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/graphicwork")}>View More<i className="fa-solid fa-arrow-right-to-bracket"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="/travel.png" className="img-fluid rounded-end  custom-img" alt="..."/>
    </div>
  </div>
</div>

{/* Three */}
 <div className="card mb-3 margins" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="/cart.png" className="img-fluid rounded-start  custom-img" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">E-commerce Development</h1>
         <h5 className="text">Launch your online store with a seamless shopping experience.We build custom <br/> 
     e-commerce websites that are fast, secure, and mobile-friendly.<br/>From product listings to secure
  checkout,<br/> we handle everything with precision.Grow your business<br/> online with a store that sells—24/7.Your 
 success is just a click away.</h5>
         <div className="quotes">
            <h4>"Your online store, built to sell—anytime, anywhere."</h4>
        </div>
         <button className="but1"  onClick={() => navigate("/ecommerce")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

{/* Four */}
 <div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">Software Development</h1>
         <h5 className="text">We turn ideas into powerful, custom-built software solutions.We develop scalable and secure<br/>
software tailored to your business needs.Whether it’s desktop, web, or mobile apps—we build with 
precision and performance.Empower your workflow with technology that works for you.<br/>
From concept to code, we deliver excellence.</h5>
 
 <div className="quotes">
            <h4>"From concept to code—we build powerful software that works."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/software")}>View More<i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="software.png" className="img-fluid rounded-end custom-img" alt="..."/>
    </div>
  </div>
</div>

{/* Five */}

 <div className="card mb-3 margins" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="/business1.png" className="img-fluid rounded-start  custom-img" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">Business Consulting</h1>
         <h5 className="text">Build your digital identity with stunning, responsive websites.<br/>
      we design user-friendly websites that reflect your brand and drive results.<br/>From business pages to e-commerce, we craft every pixel<br/>
       with purpose.Get a website that works beautifully on all devices.Let your website speak for your 
        business—professionally.</h5>
         <div className="quotes">
            <h4>"Let your website speak for your business—professionally."</h4>
        </div>
         <button className="but1"  onClick={() => navigate("/business")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

{/* Six */}
  <div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">ERP Software</h1>
         <h5 className="text">Implify your business with a powerful ERP solution tailored to your workflow.We develop intelligent<br/>
          ERP systems that streamline operations, improve efficiency, and boost productivity.From inventory<br/>
         to HR and finance, manage everything in one place.Make smarter decisions with real-time data.<br/>
         Your complete business control—digitized.</h5>
 
 <div className="quotes">
            <h4>"One system, total control—your business simplified."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/erp")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="erp2.png" className="img-fluid rounded-end custom-img " alt="..."/>
    </div>
  </div>
</div>

{/* seven */}

 <div className="card mb-3 margins" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="seo.png" className="img-fluid rounded-start custom-img" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">Search Engine Optimization</h1>
         <h5 className="text">Rank higher, reach wider, and grow faster with expert SEO.We optimize your website to appear on<br/>
          top of search engine results.From keyword research to on-page and off-page SEO—we cover it all.<br/>
          Drive organic traffic and turn visitors into customers.Let your business be found where it matters <br/>
          most—Google.</h5>
         <div className="quotes">
            <h4>"Be found where it matters—rank higher, grow faster."</h4>
        </div>
         <button className="but1"  onClick={() => navigate("/search")}>View More<i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

{/* eight */}

<div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">Digital Marketing</h1>
         <h5 className="text">Amplify your brand’s voice with targeted digital marketing strategies.We create campaigns that<br/>
          engage, convert, and grow your audience.From social media to email marketing and PPC ads—we <br/>
           cover every channel.Measure success with real-time analytics and data-driven insights.<br/>
           Take your business to the next level with digital power.</h5>
 
 <div className="quotes">
            <h4>"Marketing that connects, converts, and elevates your brand."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/digitalmarketing")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="dm.png" className="img-fluid rounded-end custom-img" alt="..."/>
    </div>
  </div>
</div>

{/* ninth */}
 <div className="card mb-3 margins" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="smm.png" className="img-fluid rounded-start custom-img" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">Social Media Management</h1>
         <h5 className="text">Boost your brand’s presence with expert social media management.<br/>
         We create, schedule, and monitor content that engages your audience.From Facebook to<br/>
          Instagram and LinkedIn—we handle all platforms with care.Build lasting relationships and grow<br/>
           your community online.Let your social media work smarter, not harder.</h5>
         <div className="quotes">
            <h4>"Smarter content. Stronger presence. Real results."</h4>
        </div>
         <button className="but1"  onClick={() => navigate("/socialmedia")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

  {/* tenth */}
  <div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">Lead Generation</h1>
         <h5 className="text">Capture quality leads that convert into loyal customers.We design targeted campaigns to attract<br/>
          and nurture prospects.Using data-driven strategies, we maximize your sales opportunities.<br/>
          Grow your pipeline with qualified leads ready to engage.Let us fuel your business growth with<br/>
          effective lead generation.</h5>
 
 <div className="quotes">
            <h4>"Turn clicks into customers with quality lead generation."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/lead")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="lead.png" className="img-fluid rounded-end custom-img" alt="..."/>
    </div>
  </div>
</div>

{/* eleventh */}
 <div className="card mb-3 margins" >
  <div className="row g-0">
    <div className="col-md-4  d-flex align-items-center">
      <img src="bb.png" className="img-fluid rounded-start custom-img" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title heading">Business Branding</h1>
         <h5 className="text">Create a brand that speaks, connects, and lasts.We craft unique brand identities through logo<br/>
          design, messaging, visuals, and strategy.From startups to established businesses, we help you<br/>
           stand out in a competitive market.Build trust and recognition with consistent branding across<br/>
          every platform.Your brand is your story—let’s tell it right.</h5>
         <div className="quotes">
            <h4>"Build a brand that speaks, connects, and lasts."</h4>
        </div>
         <button className="but1"  onClick={() => navigate("/businessbrand")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
      </div>
    </div>
  </div>
  </div>

{/* twelth */}
<div className="card mb-3 margins" >
  <div className="row g-0">
    {/* <!-- Text Content First --> */}
    <div className="col-md-8">
      <div className="card-body">
        <h1 className="card-title2">HR Services</h1>
         <h5 className="text">Streamline your workforce with smart HR solutions.At SVT Digital Info Tech, we offer end-to-end HR<br/>
          services including recruitment, payroll, employee management, and compliance.We help<br/>
         businesses build strong teams and maintain smooth operations.Save time, reduce errors, and<br/>
         focus on growth while we handle your HR needs.Your people, our priority.</h5>
 
 <div className="quotes">
            <h4>"Empowering people. Simplifying HR. Growing businesses."</h4>
        </div>
 
      <button className="but1"  onClick={() => navigate("/hr")}>View More <i class="fa-solid fa-circle-arrow-right"></i></button><br/>
        <button className="but2">START YOUR PROJECT</button>
       
      </div>
    </div>
    {/* <!-- Image Second --> */}
    <div className="col-md-4  d-flex align-items-center">
      <img src="hr.png" className="img-fluid rounded-end custom-img" alt="..."/>
    </div>
  </div>
</div>

<footer class="bg-dark text-white pt-4 pb-2 scroll-animate">
<div style={{ position: '', width: '100%', height: 'auto', overflow: 'hidden' }}>


  <div class="container text-center text-md-left">
    <div class="row">

    
<div class="col-md-4 mb-3 d-flex flex-column align-items-center scroll-animate">
  <h3 class="text-center">QUICK LINKS</h3>
  <ul class="quick-links list-unstyled text-center p-0 m-0">
    <li><a href="/" class="text-white text-decoration-none d-block mb-1">Website Designing </a></li>
    <li><a href="/courses" class="text-white text-decoration-none d-block mb-1">Graphic Work</a></li>
    <li><a href="/contact" class="text-white text-decoration-none d-block mb-1">E-Commerce Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Software Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Consulting</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">ERP Software</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Search Engine Optimization</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Digital Marketing</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Social Media Management</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Lead Generation</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Branding</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">HR Services</a></li>
  </ul>
</div>


<div class="col-md-4 mb-3 scroll-animate">
  <h3 class="text-center">ADDRESS</h3>
  <p class="contact-info text-start">
    📍 Kongu Main Rd, near Bharat Petrol Bunk, MS Nagar, Tiruppur, Tamil Nadu 641607<br/>
    📞 99168 28514<br/>
    📧 svtdigiinfo@gmail.com
  </p>
</div>

 <div class="col-md-4 mb-3 scroll-animate">
    <h3> SOCIAL MEDIA</h3>

<div>
<a
  href="https://wa.me/919916828514"  
  target="_blank"
  rel="noopener noreferrer"
>
<i class="fa-brands fa-whatsapp"></i>
</a>
<a href="https://www.facebook.com/profile.php?id=61575077092918" target="_blank">
  <i class="fa-brands fa-facebook"></i>
</a>
</div>
<div className='second'>
<a href="https://www.instagram.com/svt_digital_academy/" target="_blank">
  <i class="fa-brands fa-instagram"></i>
</a> 

<a href="https://www.youtube.com/@SVTDigitalinfotech" target="_blank">
  <i class="fa-brands fa-youtube"></i>
</a>
</div>

      </div>

    </div>

    <hr class="custom-hr" />


    <div class=" mt-3 scroll-animate">
      <h5>Terms and condition | <Link to="/privacy" className="customlink">Privacy policy</Link>
 <br/>
Copyright ©svt digital info tech. All Rights Reserved.</h5>
    </div>

  </div>
  </div>

</footer>


        </div>
    )
}

export default Allservices2;